import {z} from 'zod'
import {TimeRange} from '../timeRange/TimeRange.js'
import {mapMinutesOfDay} from '../timeRange/mapper/mapMinutesOfDay.js'

export const Workday = z
  .array(TimeRange)
  .transform((value) => value.toSorted((a, b) => mapMinutesOfDay(a.start) - mapMinutesOfDay(b.start)))
  .check((ctx) => {
    for (let i = 0; i < ctx.value.length; i++) {
      const previousDateRange = ctx.value[i - 1]
      const dateRange = ctx.value[i]

      if (previousDateRange && mapMinutesOfDay(dateRange.start) < mapMinutesOfDay(previousDateRange.end)) {
        ctx.issues.push({
          input: ctx.value[i - 1],
          path: [i - 1, 'end'],
          code: 'custom',
          message: `Time is before next start`,
        })
        ctx.issues.push({
          input: ctx.value[i],
          path: [i, 'start'],
          code: 'custom',
          message: `Time is before previous end`,
        })
      }
    }
  })
export type Workday = z.infer<typeof Workday>
